import { Message } from 'element-ui'
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
function triming(str) {
  return str ? str.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : undefined;
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

// 校验ip地址
const regIp = (ip, msg) => {
  let ip_trim = triming(ip)
  const str = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  const stripv6 = /((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/
  if (ip_trim && !str.test(ip_trim) && !stripv6.test(ip_trim)) {
    Message({
      showClose: true,
      message: msg || '请输入正确的IP地址！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }

  return true
}

// 校验域名
const regHost = (ip) => {
  const str = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
  if (ip && !str.test(ip)) {
    Message({
      showClose: true,
      message: '请输入正确的IP或域名！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验设备名称 15个字符
function regName(name) {
  if (name && name.length > 15) {
    Message({
      showClose: true,
      message: '设备名称不可超过15个字！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验所属单位长度
const regCompany = (company) => {
  if (company && company.length > 30) {
    Message({
      showClose: true,
      message: '单位字数不可超过30个字！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验流量长度
const regLength = (val, msg, length) => {
  // const _length = val.replace(/[\u0391-\uFFE5]/g,"aa").length
  // const str = /^[A-Za-z0-9-_]+$/
  // return str.test(val) && _length > length
  if (val && val.length > length) {
    Message({
      showClose: true,
      message: msg,
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验编号 英文数字中划线下划线, 长度不超过12位
const regNo = (no) => {
  const str = /^[A-Za-z0-9-_]+$/
  if (no && no.length > 12) {
    Message({
      showClose: true,
      message: '设备编号不可超过12位！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  if (no && !str.test(no)) {
    Message({
      showClose: true,
      message: '请输入正确的设备编号！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// IOC 非中
const regIOC = (ioc) => {
  const str = /^[\u4e00-\u9fa5]+$/
  if (ioc && str.test(ioc)) {
    Message({
      showClose: true,
      message: '请输入正确的IOC规则！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// IOC 非中
const regNotChinese = (ioc, msg) => {
  const str = /^[\u4e00-\u9fa5]+$/
  if (ioc && str.test(ioc)) {
    Message({
      showClose: true,
      message: msg,
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验端口
const regPort = (port, msg) => {
  const str = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/
  if (port && !str.test(port)) {
    Message({
      showClose: true,
      message: msg || '请填写正确的端口！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验域名
const regDomain = (domain) => {
  const str = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
  if (domain && !str.test(domain)) {
    Message({
      showClose: true,
      message: msg || '请填写正确的端口！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验数字
const regNumber = (num) => {
  const str = /^[0-9]*$/
  if (domain && !str.test(domain)) {
    Message({
      showClose: true,
      message: '请填写数字！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

// 校验邮箱
const regEmail = (email) => {
  const str = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  if (email && !str.test(email)) {
    Message({
      showClose: true,
      message: '请填写正确的邮箱！',
      type: 'error',
      duration: 3 * 1000
    })
    return false
  }
  return true
}

const checkIP = (rule, value, callback) => {
  const str = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  if (value && !str.test(value)) {
    callback(new Error('请输入正确的IP地址！'))
  } else {
    callback()
  }
}

const isJSON_test = (str) => {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      // console.log('转换成功：'+obj);
      return true;
    } catch (e) {
      // console.log('error：'+str+'!!!'+e);
      return false;
    }
  }
  // console.log('It is not a string!')
}
const checkEmail = (rule, value, callback) => {
  // const str = /^(([^<>()\[\]\\.,;:\s@-_*&……%￥@#！+"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const str = /^(([a-zA-Z0-9^<>()\[\]\\.,;:\s@_$#-_*&……%￥@#!！+"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (value && !str.test(value)) {
    callback(new Error('请填写正确的邮箱！'))
  } else {
    callback()
  }
}

const checkDomain = (rule, value, callback) => {
  // const str = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
  const str = /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/
  if (value && !str.test(value)) {
    callback(new Error('请填写正确的域名！'))
  } else {
    callback()
  }
}
const checkPort = (rule, value, callback) => {
  if (!value) {
    callback()
  } else if (!(/^[1-9]\d*$/.test(value) && 1 <= 1 * value && 1 * value <= 65535)) {
    callback(new Error('请输入合法的端口'))
  } else {
    callback()
  }
}

// 只能输入中文
const checkChinese = (rule, value, callback) => {
  // const str = /^[^\u4E00-\u9FA5]$/
  const str = /^[\u4E00-\u9FA5]*$/
  if (value && !str.test(value)) {
    callback(new Error('请输入中文的内容！'))
  } else if (!value) {
    callback(new Error('请输入'))
  } else {
    callback()
  }
}

export {
  regIp,
  regNo,
  regIOC,
  regName,
  regCompany,
  regLength,
  regHost,
  regNotChinese,
  regPort,
  regDomain,
  regNumber,
  regEmail,
  checkIP,
  checkEmail,
  checkDomain,
  checkPort,
  checkChinese,
  isJSON_test
}